import axios from "axios";
import env from "../variables/config";

const API_URL = env.apiUrl || "http://localhost:3000";

function encodedLocation(): string | undefined {
    try {
        return btoa(unescape(encodeURIComponent(window.location.pathname + window.location.search)));
    } catch {
        return undefined;
    }
}

/**
 * Attaches the current location to requests going to our own API, so the
 * server can attribute each call to the page it came from. Other hosts are
 * left untouched (an extra header would break their CORS preflight).
 */
export function installRequestContext() {
    axios.interceptors.request.use((config) => {
        const url = config.url || "";
        const ownApi = !/^https?:\/\//i.test(url) || url.startsWith(API_URL);
        if (ownApi) {
            const ctx = encodedLocation();
            if (ctx) config.headers.set("x-ctx", ctx);
        }
        return config;
    });
}
